import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, ValidationErrors, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth.service';
//import { STORAGE_JUNO_LANGUAGE_LIST, STORAGE_JUNO_USER } from '../../_common/constants';
import { ResetPasswordService } from './reset-password.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
        const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);
        // const isSubmitted = form && form.submitted;
        // return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
        //const invalidParent = !!(control && control.parent && control.parent.invalid && (control.parent.dirty || control.parent.touched || isSubmitted));

        return (invalidCtrl || invalidParent);
    }
}

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {
    resetPasswordForm: FormGroup;
    passwordFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}')
    ]);
    confirmPasswordFormControl = new FormControl('', [
        Validators.required
    ]);
    hidePassword = true;
    hideConfirmPassword = true;
    passwordFocused = false;
    confirmPasswordFocused = false;
    passwordMatcher = new MyErrorStateMatcher();
    token = null;
    email = null;
    isSubmitted = false;
    languageList = null;

    constructor(private formBuilder: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private resetPasswordService: ResetPasswordService,
        private translateService: TranslateService,
        private toastr: ToastrService,
        @Inject('API_URL') private apiUrl: string
    ) {
        this.resetPasswordForm = this.formBuilder.group({
            passwordFormControl: this.passwordFormControl,
            confirmPasswordFormControl: this.confirmPasswordFormControl
        }, { validator: this.checkPasswords });
    }

    ngOnInit() {
        this.passwordFocused = false;
        this.activatedRoute.queryParams.subscribe(params => {
            this.token = params['token'];
        });
        //this.languageList = JSON.parse(sessionStorage.getItem(STORAGE_JUNO_LANGUAGE_LIST));
        this.validateToken(this.token);
    }

    onHidePassword() {
        this.hidePassword = !this.hidePassword;
    }

    onHideConfirmPassword() {
        this.hideConfirmPassword = !this.hideConfirmPassword;
    }

    onPasswordFocus() { this.passwordFocused = true; }

    onPasswordBlur() { this.passwordFocused = false; }

    onConfirmPasswordFocus() { this.confirmPasswordFocused = true; }

    onConfirmPasswordBlur() { this.confirmPasswordFocused = false; }

    onChangeLanguage(language: string) {
        this.translateService.use(language);
    } 

    onSignOut() {
        this.authService.signOut();
    }

    passwordEyeColour() { return this.passwordFormControl.errors ? 'warn' : this.passwordFocused ? 'primary' : ''; }

    confirmPasswordEyeColour() { return this.confirmPasswordFormControl.errors || this.resetPasswordForm.hasError('notSame') ?
         'warn' : this.confirmPasswordFocused ? 'primary' : '';
    }

    checkPasswords(group: FormGroup) {
        let password = group.controls.passwordFormControl.value;
        let confirmPassword = group.controls.confirmPasswordFormControl.value;

        if (!password || !confirmPassword) {
            return null;
        }

        return password === confirmPassword ? null : { notSame: true }
    }

    validateToken(token: string) {
        this.resetPasswordService.validateToken(token).subscribe(response => {
            if(!response)
                return;
            
            response.model ? this.email = response.model : this.email;
            if(response.error.message) { 
                this.toastr.error(response.error.message);
            }         
        });        
    }

    setPassword() {
        const body = {
            username: this.email,
            password: this.passwordFormControl.value
        };

        this.resetPasswordService.setPassword(body).subscribe(response => {
            if(response)
                this.isSubmitted = true;
        });
    }
}
